import {charcoal} from '../sass/base/_exports.sass';

export const PollLineIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 5.33268H20.6667V7.99935H10.6667V5.33268ZM6 8.66602C5.46957 8.66602 4.96086 8.4553 4.58579 8.08023C4.21071 7.70516 4 7.19645 4 6.66602C4 6.13558 4.21071 5.62687 4.58579 5.2518C4.96086 4.87673 5.46957 4.66602 6 4.66602C6.53043 4.66602 7.03914 4.87673 7.41421 5.2518C7.78929 5.62687 8 6.13558 8 6.66602C8 7.19645 7.78929 7.70516 7.41421 8.08023C7.03914 8.4553 6.53043 8.66602 6 8.66602ZM6 17.9993C5.46957 17.9993 4.96086 17.7886 4.58579 17.4136C4.21071 17.0385 4 16.5298 4 15.9993C4 15.4689 4.21071 14.9602 4.58579 14.5851C4.96086 14.2101 5.46957 13.9993 6 13.9993C6.53043 13.9993 7.03914 14.2101 7.41421 14.5851C7.78929 14.9602 8 15.4689 8 15.9993C8 16.5298 7.78929 17.0385 7.41421 17.4136C7.03914 17.7886 6.53043 17.9993 6 17.9993ZM6 27.1993C5.46957 27.1993 4.96086 26.9886 4.58579 26.6136C4.21071 26.2385 4 25.7298 4 25.1993C4 24.6689 4.21071 24.1602 4.58579 23.7851C4.96086 23.4101 5.46957 23.1993 6 23.1993C6.53043 23.1993 7.03914 23.4101 7.41421 23.7851C7.78929 24.1602 8 24.6689 8 25.1993C8 25.7298 7.78929 26.2385 7.41421 26.6136C7.03914 26.9886 6.53043 27.1993 6 27.1993ZM10.6667 14.666H24.6667V17.3327H10.6667V14.666ZM10.6667 23.9993H28V26.666H10.6667V23.9993Z"
        fill={color}
      />
    </svg>
  );
};
